import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu\">\r\n<line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n<line x1=\"3\" y1=\"18\" x2=\"21\" y2=\"18\" stroke=\"#3A3A3A\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol